
import { useState, useRef } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import QuickAccessSection from './components/QuickAccessSection';
import GuidelinesGrid from './components/GuidelinesGrid';
import StatsSection from './components/StatsSection';
import Footer from './components/Footer';

export default function HomePage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedAgency, setSelectedAgency] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const guidelinesRef = useRef<HTMLDivElement>(null);

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    // Scroll to guidelines section
    guidelinesRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleAgencyFilter = (agency: string) => {
    setSelectedAgency(agency);
    // Scroll to guidelines section
    guidelinesRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleCategoryFilter = (category: string) => {
    setSelectedCategory(category);
  };

  return (
    <div className="min-h-screen bg-slate-900">
      <Header />
      <HeroSection onSearch={handleSearch} onAgencyFilter={handleAgencyFilter} />
      <QuickAccessSection onCategorySelect={handleCategoryFilter} />
      <div ref={guidelinesRef}>
        <GuidelinesGrid 
          searchQuery={searchQuery}
          selectedAgency={selectedAgency}
          selectedCategory={selectedCategory}
        />
      </div>
      <StatsSection />
      <Footer />
    </div>
  );
}
